import { Button } from '@/components/Button';
import PropTypes from 'prop-types';
import { contactUs } from '@/utils';

// Benefit category component extracted for reuse
const BenefitCategory = ({ title, benefits }) => (
  <div className="flex w-full flex-col gap-2">
    <div className="flex w-full flex-row items-center">
      <h3 className="text-left font-subtitle-subtitle-1-font-family text-subtitle-subtitle-1-font-size font-subtitle-subtitle-1-font-weight leading-subtitle-subtitle-1-line-height text-neutral-neutral-70">
        {title}
      </h3>
    </div>
    <div className="h-0 w-full border-t border-solid border-neutral-neutral-70"></div>
    <ul className="flex flex-col gap-2 pt-2">
      {benefits.map((benefit) => (
        <li
          key={benefit}
          className="font-body-body-3-font-family text-left text-body-body-3-font-size font-body-body-3-font-weight leading-body-body-3-line-height text-neutral-neutral-50"
        >
          {benefit}
        </li>
      ))}
    </ul>
  </div>
);

BenefitCategory.propTypes = {
  title: PropTypes.string.isRequired,
  benefits: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const Benefits = () => {
  // Benefits data
  const benefitsData = [
    {
      category: 'Master Real Estate Developers',
      items: [
        'Easy integration with real estate platform and EAM system',
        'Personalised interior design offering',
        'Comprehensive end-to-end process',
      ],
    },
    {
      category: 'Real Estate Agencies',
      items: [
        'Increacing unit price',
        'Personalized attractive interior design',
        'User friendly digital tool with WOW factor',
      ],
    },
    {
      category: 'Furniture Vendors',
      items: [
        'Ordering without measurement requirements',
        'No need to have own IT system',
        'Additional sales channel',
      ],
    },
    {
      category: '3rd party services',
      items: [
        'Additional sale channels',
        'Clear order statement with user friendly interface',
        '\u00A0',
      ],
    },
  ];

  return (
    <section className="section-container">
      <div className="flex flex-col items-center gap-8 md:gap-10">
        {/* Section header */}
        <div className="section-title self-start">
          <div className="section-title-prefix">partnership</div>
          <div className="section-title-main">benefits</div>
        </div>

        {/* Benefits grid */}
        <div className="flex w-full flex-col gap-8 md:gap-[52px]">
          {/* Row 1 */}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-20">
            <BenefitCategory
              title={benefitsData[0].category}
              benefits={benefitsData[0].items}
            />
            <BenefitCategory
              title={benefitsData[1].category}
              benefits={benefitsData[1].items}
            />
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-20">
            <BenefitCategory
              title={benefitsData[2].category}
              benefits={benefitsData[2].items}
            />
            <BenefitCategory
              title={benefitsData[3].category}
              benefits={benefitsData[3].items}
            />
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-4 w-full max-w-[280px]">
          <Button title="Become a partner" onClick={contactUs} />
        </div>

        {/* Feature image */}
        <img
          className="mt-6 h-auto w-full rounded-[20px] object-cover md:h-[385px]"
          src="image2.png"
          alt="Partnership benefits"
          loading="lazy"
        />
      </div>
    </section>
  );
};
